/**
 * 인증 관련 검증 함수들
 */

/**
 * 이메일 유효성 검증
 * @param {string} email - 검증할 이메일
 * @returns {boolean} - 유효성 여부
 */
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

/**
 * 비밀번호 유효성 검증 (회원가입용)
 * @param {string} password - 검증할 비밀번호
 * @param {boolean} isSignup - 회원가입 모드 여부
 * @returns {string} - 에러 메시지 (없으면 빈 문자열)
 */
export const validatePassword = (password, isSignup = false) => {
  if (!isSignup) return '';
  
  const minLength = 8;
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
  const errors = [];
  
  if (password.length < minLength) {
    errors.push(`• 최소 ${minLength}자 이상이어야 합니다`);
  }
  if (!hasNumbers) {
    errors.push('• 숫자를 포함해야 합니다');
  }
  if (!hasSpecialChar) {
    errors.push('• 특수문자를 포함해야 합니다');
  }
  
  return errors.length > 0 ? errors.join('\n') : '';
};

/**
 * 비밀번호 확인 검증
 * @param {string} password - 원본 비밀번호
 * @param {string} confirmPassword - 확인 비밀번호
 * @returns {string} - 에러 메시지 (없으면 빈 문자열)
 */
export const validatePasswordConfirm = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return '비밀번호가 일치하지 않습니다.';
  }
  return '';
}; 